export default __webpack_public_path__ + "images/f03c247f45ab3b1b96db0b85010a8648-Barlow-Medium.woff2";